import React, { useEffect, useState } from "react";
import ijcaov1 from '../assets/images/ijcapv1.webp';
import ijcaov2 from '../assets/images/ijcapv2.webp';
import ijcaov3 from '../assets/images/ijcapv3.webp';
import ijcaov4 from '../assets/images/ijcap4.webp';
import ijcaov5 from '../assets/images/ijcapv5.webp';
import ijcaov6 from '../assets/images/ijcapv6.webp';
import AOS from "aos";
import 'aos/dist/aos.css';
import axios from "axios";
import { apiUrl, assetsUrl } from "../config/Config";
import Spinner from "react-activity/dist/Spinner";
import { useNavigate } from "react-router-dom";


const Ijcapjournals = () =>{
    const [showloading, setshowloding] = useState(false);
        const [fetcheddata, setfetcheddata] = useState([]);
        const navigate = useNavigate();

        const fetchcommiteedata = async() => {
            setshowloding(true);
            const headers = {
                headers: {
                  "Content-Type": "application/json",
                },
              };
              let resp = await axios
              .get(apiUrl + "getuserijcapjournals", headers)
              .then((res) => {
                if (res.data.status == "success" && res?.data?.data?.length > 0) {
                    setfetcheddata(res?.data?.data)
                    setshowloding(false);
                } else {
                    setfetcheddata([])
                    setshowloding(false);
                }
              })
              setshowloding(false);
    
        }

        const handleclickjournal = (journal) => {
            if(journal) {
                // navigate(assetsUrl+'ijcapjournals/'+journal);
                window.open(assetsUrl + 'ijcapjournals/' + journal, '_blank');
            }
        }


     useEffect(() => {
                    AOS.init();
                    AOS.refresh();
                    fetchcommiteedata();
                }, [])
    return (
        <div>
              <section className="gallery-main-section">
                <div className="text-center about-tiilte-sec">
                    <p className="about-tiilte-sec-head">IJCAP Journals</p>
                    <p className="about-tiilte-sec-subhead"> home <i class="fa fa-angle-double-right    about-bredcumb-arrow" aria-hidden="true"></i>
                    IJCAP Journals</p>
                </div>
            </section>
            <section className="alumini-comitee-member-sec">
                <div className="container">
                    <div className="row">

                        

                        {
                            fetcheddata?.length > 0 ?
                            fetcheddata?.map((item, index) => {
                                return (
                                  <div
                                    className="col-12 col-md-6 col-lg-4 mb-2 mb-md-4"
                                    data-aos="fade-up"
                                    data-aos-delay="300"
                                    data-aos-duration="300"
                                    key={index}
                                    onClick={() => {handleclickjournal(item?.journal)}}
                                  >
                                    <div className="app-container">
                                      <div className="hover-image-container">
                                        <img
                                          src={assetsUrl+"ijcapjournals/"+item?.image}
                                          alt="Hover"
                                          className="hover-image"
                                        />
                                        <div className="social-overlay"></div>
                                      </div>
                                    </div>
                                    <p className="alumini-comitee-member-name">
                                      {item.name}
                                    </p>
                                  </div>
                                );
                            }) :
                            showloading ?
                            <div>
                                 <Spinner color='#264790' size={22} className='spinnerCenter' />
                            </div>
                            :
                            <p className="alumini-comitee-member-name" style={{textAlign: 'center'}}>IJCAP Journals not added yet</p>
                        }

                        
                    </div>
                </div>
            </section>
        </div>
    )
}
export default Ijcapjournals;